import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import $ from "jquery";

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

import {getCurrentLayout} from "../../../appLayout";
// import COLOR_THEMES, {COLORS} from "../../../../colorThemes";
import {featureInterface} from "../../../../interfaces/featureInterface";
import {updateCanvasCount} from "../../../../actions/actionFunctions";
import {clickOnSimilarFeatures, getApplyToLogic} from "../lookNavigationFunctions";
import {IS_QKB_UI} from "../../../../config";
import ActionTypes from "../../../../misc/actionTypes";
import LookAllWallsRadioButtonSmall from "./lookAllWallsRadioButtonSmall";


const LookAllWallsRadioButton = (props) => {

  const {lookFeature, lookActiveFeature, intl, updateCanvasCount, dispatch, showColumnCheckbox, type, viewType,
    showTutorialToolTip, fabricatorData} = props;

  const wallFeature = lookFeature || lookActiveFeature;

  if (!wallFeature || fabricatorData.isEncore) {
    return null
  }

  const layout = getCurrentLayout();

  const applyToLogic = getApplyToLogic(wallFeature);
  if (!applyToLogic) {
    return null
  }

  const {translateId, setApplyToFunction, applyToArrayAll, currentApplyToArray} = applyToLogic;
  const checked = currentApplyToArray.includes(wallFeature.partId);

  const updateCanvas = () => {
    if (IS_QKB_UI) {
      $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
    } else {
      updateCanvasCount();
    }
  }

  const allWallsCheckboxClick = async () => {
    if (checked) { // already enabled
      if (currentApplyToArray.length) {
        dispatch(setApplyToFunction([], true))
      }
      applyToArrayAll.forEach(wallPartId => {
        const subPart = layout.getSubPartByPartId(wallPartId);
        if (!subPart || (subPart.part.partId === wallFeature.partId) || !subPart.part.activeFeatureBeforeAllWalls) {
          return null
        }
        subPart.part.activeFeatureBeforeAllWalls.clickFromAllWalls(true);
      });
      updateCanvas();
      return
    } // already enabled end

    if (applyToArrayAll.length !== currentApplyToArray.length) {
      dispatch(setApplyToFunction([...applyToArrayAll], true)) // update checkbox
    }
    await clickOnSimilarFeatures(wallFeature, applyToLogic);
    updateCanvas();
  };

  if (showColumnCheckbox) {
    return (
      <div className="ui-radio-block">
        <span className="ui-radio-label nowrap"><FormattedMessage id={translateId}/>:</span>
        <button className={"ui-radio ui-radio--small" + (checked ? " ui-radio--checked" : "")}
                onClick={allWallsCheckboxClick}>
          <span className="ui-radio-circle"/>
          <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
          <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
        </button>
      </div>
    )
  }

  if (type === "small") {
    return <LookAllWallsRadioButtonSmall allWallsCheckboxClick={allWallsCheckboxClick}
                                         lookFeature={lookFeature}
                                         showTutorialToolTip={showTutorialToolTip}
                                         checked={checked}
                                         viewType={viewType}
                                         translateId={translateId}/>
  }

  return (
    <FormControlLabel
      label={intl.formatMessage({id: translateId})}
      control={
        <Switch
          checked={checked}
          className="gm-ios-checkbox"
          // classes={{
          //   switchBase: "switchBase",
          //   bar: "bar",
          //   icon: "icon",
          //   iconChecked: "iconChecked",
          //   checked: "checked",
          // }}
          disableRipple
          onChange={allWallsCheckboxClick}
          color="primary"
        />
      }
    />
  )
};

LookAllWallsRadioButton.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  showColumnCheckbox: PropTypes.bool,
  showTutorialToolTip: PropTypes.bool,
  type: PropTypes.string,
  viewType: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookWallsApplyTo} = store.lookState;
  const {activeTheme} = store.serverState;
  const {countertopsApplyToArray, cabinetsApplyTo, cabinetsApplyToBathroom, edgesApplyTo, handlesApplyToBathroom,
    countertopsApplyToArrayBathroom} = store.navigationState;
  const fabricatorData = store.fabricatorState;

  return {
    lookActiveFeature,
    activeTheme,
    countertopsApplyToArray, cabinetsApplyTo, lookWallsApplyTo, cabinetsApplyToBathroom, edgesApplyTo,
    countertopsApplyToArrayBathroom, handlesApplyToBathroom, // update radio button on click
    fabricatorData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCanvasCount: () => dispatch(updateCanvasCount()),
    dispatch,
  }
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAllWallsRadioButton)
)
